import React from 'react';
import { Check, Zap, Users, BookOpen, Video, ArrowRight } from 'lucide-react';

const Continuidad = () => {
  const caracteristicas = [
    {
      icon: <BookOpen size={24} />,
      title: "Contenido mensual exclusivo",
      description: "Actualizaciones sobre las últimas herramientas de IA aplicadas al derecho."
    },
    {
      icon: <Video size={24} />,
      title: "Webinars en vivo",
      description: "Sesión mensual de Q&A y casos prácticos con expertos."
    },
    {
      icon: <Users size={24} />,
      title: "Comunidad privada",
      description: "Acceso a un grupo exclusivo de abogados innovadores."
    },
    {
      icon: <Zap size={24} />,
      title: "Biblioteca de prompts",
      description: "Plantillas actualizadas cada mes para casos reales."
    }
  ];

  const incluye = [
    "Acceso a la plataforma de recursos",
    "Nuevas plantillas de prompts cada mes",
    "Casos de uso documentados",
    "Actualizaciones sobre normativa y IA",
    "Descuentos en servicios de consultoría",
    "Soporte técnico por email",
    "Certificado de formación continua"
  ];

  const scrollToContacto = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="continuidad" className="bg-reset-dark py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-reset-gold uppercase tracking-widest text-sm mb-4 block">
            Membresía mensual
          </span>
          <h2 className="text-5xl md:text-6xl font-light text-white leading-tight mb-6">
            <span className="italic text-reset-gold">Continuidad</span> tecnojurídica
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Mantén tu despacho a la vanguardia con actualización constante, nuevas herramientas y acceso a una comunidad de abogados que ya están en el futuro.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {caracteristicas.map((item, index) => (
            <div 
              key={index}
              className="bg-reset-black border border-reset-gold/20 p-6 hover:border-reset-gold/50 transition-all"
            >
              <div className="text-reset-gold mb-4">{item.icon}</div>
              <h3 className="text-white font-semibold mb-2">{item.title}</h3>
              <p className="text-gray-400 text-sm">{item.description}</p>
            </div>
          ))}
        </div>

        {/* Two Columns: Benefits & CTA */}
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Left: What's Included */}
          <div>
            <h3 className="text-2xl font-semibold text-white mb-6">
              Qué incluye la membresía
            </h3>
            <div className="space-y-3">
              {incluye.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <Check className="text-reset-gold shrink-0 mt-0.5" size={20} />
                  <p className="text-gray-300">{item}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 bg-reset-black border border-reset-gold/30 p-6">
              <p className="text-reset-gold font-semibold mb-2">
                🎓 Formación continua homologada
              </p>
              <p className="text-gray-400 text-sm">
                Cada trimestre emitimos certificado de formación continua válido para colegios profesionales.
              </p>
            </div>
          </div>

          {/* Right: CTA Box */}
          <div className="bg-reset-black border-2 border-reset-gold p-8 sticky top-24">
            <div className="text-center mb-6">
              <p className="text-gray-400 text-sm uppercase tracking-wider mb-2">Precio mensual</p>
              <div className="flex items-end justify-center gap-2">
                <span className="text-5xl font-bold text-white">117€</span>
                <span className="text-gray-400 mb-2">/mes</span>
              </div>
              <p className="text-gray-500 text-sm mt-2">IVA incluido • Sin permanencia • Cancela cuando quieras</p>
            </div>

            <button 
              onClick={scrollToContacto}
              data-testid="continuidad-cta-button"
              className="w-full bg-reset-gold hover:bg-reset-gold-light text-black py-4 text-lg font-bold transition-all flex items-center justify-center gap-2 group mb-4"
            >
              Unirme ahora
              <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} />
            </button>

            <div className="space-y-2 text-sm text-gray-400">
              <div className="flex items-center gap-2">
                <Check size={16} className="text-reset-gold" />
                <span>Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-2">
                <Check size={16} className="text-reset-gold" />
                <span>Garantía de 14 días</span>
              </div>
              <div className="flex items-center gap-2">
                <Check size={16} className="text-reset-gold" />
                <span>Pago seguro con Stripe</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom CTA for Mobile */}
        <div className="md:hidden text-center mt-12">
          <button 
            onClick={scrollToContacto}
            className="bg-reset-gold hover:bg-reset-gold-light text-black px-10 py-4 text-lg font-bold transition-all inline-flex items-center gap-2"
          >
            Unirme ahora
            <ArrowRight size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Continuidad;